import { Box, Grid } from '@mui/material';
import { Title } from '../../auth/styled';
import Modal from 'react-responsive-modal';
import Save from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import ButtonGeneral from '../../../components/general/buttons/buttonGeneral';

interface Props {
    open: boolean;
    onCloseCsvViewer: () => void;
    onAccept?: (deleteAndSave: boolean) => void;
}

export const VerifyReplace = ({ open, onCloseCsvViewer, onAccept }: Props) => {
    return (
        <Modal
            open={open}
            onClose={onCloseCsvViewer}
            styles={{ modal: { maxWidth: '80%', minWidth: '80%' } }}
        >
            <Box sx={{ mt: 1 }}>
                <Title variant="h4">
                    Es posible que la lista seleccionada tenga datos, por favor
                    seleccione la opción adecuada para su caso.
                </Title>
                <Grid item xs={12} sx={{ textAlign: 'right' }} mt={3}>
                    <ButtonGeneral
                        onClick={() => onAccept && onAccept(true)}
                        startIcon={<CancelIcon color="secondary" />}
                        title="Eliminar y guardar"
                    />
                    <ButtonGeneral
                        onClick={() => onAccept && onAccept(false)}
                        startIcon={<Save color="secondary" />}
                        title="Agregar a lo existente"
                        sx={{ ml: 1 }}
                    />
                </Grid>
            </Box>
        </Modal>
    );
};
